// Succinct Ghost Theme JS
import "../css/index.css";
import infiniteScroll from "./infiniteScroll";
import initAnimations from "./animations";
import buildOutline from "./outline";

// Infinite scroll for post feeds
infiniteScroll();

// Entrance animations + outline sidebar
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initAnimations();
        buildOutline();
    });
} else {
    initAnimations();
    buildOutline();
}
